/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./header-block.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./header-block.component";
var styles_HeaderBlockComponent = [i0.styles];
var RenderType_HeaderBlockComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_HeaderBlockComponent, data: {} });
export { RenderType_HeaderBlockComponent as RenderType_HeaderBlockComponent };
export function View_HeaderBlockComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_HeaderBlockComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-header-block", [], null, null, null, View_HeaderBlockComponent_0, RenderType_HeaderBlockComponent)), i1.ɵdid(1, 114688, null, 0, i2.HeaderBlockComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var HeaderBlockComponentNgFactory = i1.ɵccf("cc-header-block", i2.HeaderBlockComponent, View_HeaderBlockComponent_Host_0, {}, {}, ["*"]);
export { HeaderBlockComponentNgFactory as HeaderBlockComponentNgFactory };
